"use strict";
import { popupRegistry } from "components/Popups/registry";
import { PopupType } from "components/Popups/types";
import { handleOnChainStep } from "state/sagas/transactions/utils";
import {
  TransactionType
} from "state/transactions/types";
import { call } from "typed-redux-saga";
import { TransactionStepType } from "features/transactions/steps/types";
import { createSaga } from "utils/saga";
function* lpIncentivesClaim(params) {
  const { account, claimData, chainId, tokenAddress, selectChain, onSuccess, onFailure, setCurrentStep } = params;
  try {
    if (!claimData.claim) {
      throw new Error("No claim data provided");
    }
    if (claimData.claim.chainId !== chainId) {
      const chainSwitched = yield* call(selectChain, claimData.claim.chainId);
      if (!chainSwitched) {
        onFailure(new Error("Failed to switch to the required chain"));
        return;
      }
    }
    const info = {
      type: TransactionType.LP_INCENTIVES_CLAIM_REWARDS,
      tokenAddress
    };
    const step = {
      type: TransactionStepType.CollectLpIncentiveRewardsTransactionStep,
      txRequest: claimData.claim
    };
    const hash = yield* call(handleOnChainStep, {
      account,
      step,
      info,
      setCurrentStep,
      shouldWaitForConfirmation: false
    });
    popupRegistry.addPopup({ type: PopupType.Transaction, hash }, hash);
    yield* call(onSuccess);
  } catch (error) {
    onFailure(error instanceof Error ? error : new Error("Failed to claim LP incentives"));
  }
}
export const lpIncentivesClaimSaga = createSaga(lpIncentivesClaim, "lpIncentivesClaimSaga");
